import { Observable, of } from 'rxjs';
import { ICryptoRequest } from './../domain/crypto-request.entity';
import { Injectable } from '@angular/core';
import { PartnerDefaultDiscount } from '../domain/partner.entity';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  apiUrl = environment.apiBaseUrl + 'settings/';

  constructor(
    private httpClient: HttpClient) {
  }

  updateManualPartnerMakesDiscount(body: UpdatePartnerMakesDiscountRequest): Observable<void> {
    return this.httpClient.post<void>(this.apiUrl + 'manual/discount/update', body, this.getOptions());
  }

  updateDealerManufacturerDefaultDiscount(body: any): Observable<void> {
    return this.httpClient.post<void>(this.apiUrl + 'default/discount/update', body, this.getOptions());
  }

  forceUpdateDealerManufacturerShopDiscount(body: any): Observable<void> {
    return this.httpClient.post<void>(this.apiUrl + 'default/discount/update/force', body, this.getOptions());
  }

  getDealerManufacturerDefaultDiscounts(): Observable<PartnerDefaultDiscount[]> {
    return this.httpClient.get<PartnerDefaultDiscount[]>(this.apiUrl + 'default/discount', this.getOptions());
  }

  updateAllowSaleCrashParts(body: any): Observable<void> {
    return this.httpClient.post<void>(
      this.apiUrl + 'crashparts/update', body, this.getOptions());
  }

  getAllowSaleCrashParts(): Observable<AllowCrashParts> {
    return this.httpClient.get<AllowCrashParts>(this.apiUrl + 'crashparts', this.getOptions());
  }

  insertOrUpdateRegularShopDefaultDiscount(body: RegularShopDefaultDiscountsRequest): Observable<void> {
    return this.httpClient.post<void>(this.apiUrl + 'default/regular/update', body, this.getOptions());
  }

  forceUpdateRegularShopDiscount(body: RegularShopDefaultDiscountsRequest): Observable<void> {
    return this.httpClient.post<void>(this.apiUrl + 'default/regular/update/force', body, this.getOptions());
  }

  getRegularShopDefaultDiscounts(): Observable<RegularShopDefaultDiscount[]> {
    return this.httpClient.get<RegularShopDefaultDiscount[]>(this.apiUrl + 'default/regular', this.getOptions());
  }

  getSpecialPricingDefaultDiscounts(): Observable<SpecialPricingDefaultDiscount[]> {
    return this.httpClient.get<SpecialPricingDefaultDiscount[]>(this.apiUrl + 'default/upfrontnonvalutrax', this.getOptions());
  }

  insertOrUpdateSpecialPricingShopDefaultDiscount(body: SpecialPricingShopDefaultDiscountsRequest): Observable<void> {
    return this.httpClient.post<void>(this.apiUrl + 'default/upfrontNonValutrax/update', body, this.getOptions());
  }

  forceUpdateSpecialPricingShopDiscount(body: SpecialPricingShopDefaultDiscountsRequest): Observable<void> {
    return this.httpClient.post<void>(this.apiUrl + 'default/upfrontNonValutrax/update/force', body, this.getOptions());
  }

  deleteSpecialPricingDiscount(body: SpecialPricingDiscountDeleteRequest): Observable<void> {
    return this.httpClient.post<void>(this.apiUrl + 'default/upfrontNonValutrax/delete', body, this.getOptions());
  }

  getCollisionShopDefaultDiscounts(): Observable<CollisionShopDefaultDiscount[]> {
    return this.httpClient.get<CollisionShopDefaultDiscount[]>(this.apiUrl + 'default/collision', this.getOptions());
  }

  insertOrUpdateCollisionShopDefaultDiscount(body: CollisionShopDefaultDiscountsRequest): Observable<void> {
    return this.httpClient.post<void>(this.apiUrl + 'default/collision/update', body, this.getOptions());
  }

  forceUpdateCollisionShopDiscount(body: CollisionShopDefaultDiscountsRequest): Observable<void> {
    return this.httpClient.post<void>(this.apiUrl + 'default/collision/update/force', body, this.getOptions());
  }

  getDiscountOeShopDefaultDiscounts(): Observable<DiscountOeShopDefaultDiscount[]> {
    return this.httpClient.get<DiscountOeShopDefaultDiscount[]>(this.apiUrl + 'default/discountOe', this.getOptions());
  }

  insertOrUpdateDiscountOeShopDefaultDiscount(body: DiscountOeShopDefaultDiscountsRequest): Observable<void> {
    return this.httpClient.post<void>(this.apiUrl + 'default/discountOe/update', body, this.getOptions());
  }

  forceUpdateDiscountOeShopDiscount(body: DiscountOeShopDefaultDiscountsRequest): Observable<void> {
    return this.httpClient.post<void>(this.apiUrl + 'default/discountOe/update/force', body, this.getOptions());
  }


  isOEMSupplier(): Observable<IsOemSupplier> {
    return this.httpClient.get<IsOemSupplier>(this.apiUrl + 'isOemSupplier', this.getOptions());
  }


  private getOptions() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return { headers };
  }
}

export interface RegularShopDefaultDiscount {
  dealerManufacturerDefaultDiscountId: number;
  dealerId: number;
  manufacturerId: number;
  manufacturerName: string;
  emsMakeId: number;
  name: string;
  discount?: number;
  discountTypeCode?: number;


  // ---- for ux ---
  selected?: boolean;
}

export interface SpecialPricingDefaultDiscount {
  dealerManufacturerDefaultDiscountId: number;
  dealerId: number;
  manufacturerId: number;
  manufacturerName: string;
  emsMakeId: number;
  name: string;
  discount?: number;
  discountTypeCode?: number;
  // ---- for ux ---
  selected?: boolean;
}

export interface RegularShopDefaultDiscountsRequest extends ICryptoRequest {
  discounts?: RegularShopDefaultDiscountUpdateRequest[];
}

export interface SpecialPricingShopDefaultDiscountsRequest extends ICryptoRequest {
  discounts?: SpecialPricingShopDefaultDiscountUpdateRequest[];
}

export interface SpecialPricingDiscountDeleteRequest extends ICryptoRequest {
  dealerId: number;
  emsMakeId: number;
  shopId?: number;
  defaultOnly?: boolean;
}
export interface RegularShopDefaultDiscountUpdateRequest {
  discountTypeCode?: number;
  discount?: number;
  dealerId?: number;
  emsMakeId?: number;
}

export interface SpecialPricingShopDefaultDiscountUpdateRequest {
  discountTypeCode?: number;
  discount?: number;
  dealerId?: number;
  emsMakeId?: number;
}



export interface UpdatePartnerMakesDiscountRequest extends ICryptoRequest {
  discountType?: number;
  discount?: number;
  givenRebate?: number;
  discountId: number;
  userId: number;
  shopId?: number;
  makeId?: number;
  discountTypeCode?: number;
  manId?: number;
}

export interface AllowCrashParts extends ICryptoRequest {
  allowSaleCrashParts: boolean;
}

export interface CollisionShopDefaultDiscountsRequest extends ICryptoRequest {
  discounts?: SpecialPricingShopDefaultDiscountUpdateRequest[];
}

export interface CollisionShopDefaultDiscountUpdateRequest {
  discountTypeCode?: number;
  discount?: number;
  dealerId?: number;
  emsMakeId?: number;
}

export interface CollisionShopDefaultDiscount {
  dealerManufacturerDefaultDiscountId: number;
  dealerId: number;
  manufacturerId: number;
  manufacturerName: string;
  emsMakeId: number;
  name: string;
  discount?: number;
  discountTypeCode?: number;


  // ---- for ux ---
  selected?: boolean;
}

export interface IsOemSupplier extends ICryptoRequest {
  isOEMSupplier: boolean;
}

export interface DiscountOeShopDefaultDiscount {
  dealerManufacturerDefaultDiscountId: number;
  dealerId: number;
  manufacturerId: number;
  manufacturerName: string;
  emsMakeId: number;
  name: string;
  discount?: number;
  // OE Discount only supports List Minus (discountTypeCode = 1)
  discountTypeCode?: number;

  // ---- for ux ---
  selected?: boolean;
  valid?: boolean;
}

export interface DiscountOeShopDefaultDiscountUpdateRequest {
  discount?: number;
  dealerId?: number;
  emsMakeId?: number;
  // Always 1 (List Minus) — enforced at save time
  discountTypeCode?: number;
}

export interface DiscountOeShopDefaultDiscountsRequest extends ICryptoRequest {
  discounts?: DiscountOeShopDefaultDiscountUpdateRequest[];
}
